module.exports = __webpack_public_path__ + "img/close.4ec07064.svg";